import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyAksAzUb_vprD5r0PKCyIRRccZAMxnf3gI",
    authDomain: "municipal-connectionz.firebaseapp.com",
    projectId: "municipal-connectionz",
    storageBucket: "municipal-connectionz.firebasestorage.app",
    messagingSenderId: "514375815390",
    appId: "1:514375815390:web:85f411889b9a04cf7df24f",
    measurementId: "G-RE27PKFVE1"
  };

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }